import React, { useEffect, useState } from "react";
import {
  nouveautesDe,
  nouveautesAffichablesDe,
  marquerSectionVue,
  surChangementDesVues,
} from "../../Utils/nouveautes";

/**
 * Les deux morceaux visibles de l'idee de Nicolas du 03/09 : la pastille sur
 * l'entree de menu, et le bloc « Nouveauté » en bas de la page.
 *
 * Le registre et les regles vivent dans Utils/nouveautes.js. Ici il n'y a que
 * du dessin.
 */

/**
 * La marque « Nouveau », posee sur une entree de menu.
 *
 * C'etait un point bleu de 8 px. Retour de Nicolas du 04/09 : « je vois que
 * Google ajoute un "Nouveau" sur ces nouvelles fonctionnalites, j'aime bien
 * cette visu, peux-tu l'appliquer a nos nouveautes ? ». Il a raison, et pour
 * une raison qui se dit : un point demande qu'on devine ce qu'il veut dire,
 * un mot le dit. Personne ne survole une pastille pour lire son infobulle.
 *
 * Elle ne rend RIEN quand il n'y a rien a signaler -- pas un espace reserve,
 * pas un gris. Une marque qu'on voit tout le temps ne se voit plus.
 */
export function PastilleNouveaute({ section, titre }) {
  // L'etat « deja vu » arrive du compte utilisateur, donc apres coup : on se
  // reveille quand il descend, sinon la marque resterait allumee jusqu'au
  // prochain rendu du menu.
  const [, rafraichir] = useState(0);
  useEffect(() => surChangementDesVues(() => rafraichir((n) => n + 1)), []);

  const nouvelles = nouveautesDe(section);
  if (!nouvelles.length) return null;

  const libelle =
    nouvelles.length > 1
      ? `${nouvelles.length} nouveautés dans cette section`
      : "Nouveauté dans cette section";

  return (
    <span
      title={titre || libelle}
      aria-label={libelle}
      style={{
        display: "inline-block",
        marginLeft: 8,
        padding: "1px 7px",
        borderRadius: 999,
        background: "#e8f0fe",
        color: "#1a73e8",
        fontSize: 11,
        fontWeight: 700,
        lineHeight: "16px",
        letterSpacing: 0.1,
        verticalAlign: "middle",
        flex: "none",
        whiteSpace: "nowrap",
      }}
    >
      Nouveau
    </span>
  );
}

/**
 * Le bloc de bas de page.
 *
 * Il affiche les nouveautes FRAICHES de la section, vues ou non : celle qui
 * vient d'ouvrir l'ecran doit pouvoir lire ce qui a change, meme si la
 * pastille vient de s'eteindre sous son clic.
 *
 * L'ouverture de la page marque la section comme vue -- le geste de travail
 * vaut lecture, on ne demande a personne de cliquer sur une croix.
 */
export function BlocNouveaute({ section }) {
  const [nouvelles] = useState(() => nouveautesAffichablesDe(section));

  useEffect(() => {
    marquerSectionVue(section);
  }, [section]);

  if (!nouvelles.length) return null;

  return (
    <div
      style={{
        marginTop: 18,
        padding: "14px 16px",
        background: "#f2f8fd",
        border: "1px solid #cfe3f3",
        borderRadius: 12,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontSize: 12,
          fontWeight: 800,
          color: "#0a7fbe",
          marginBottom: 10,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            display: "inline-block",
            padding: "1px 7px",
            borderRadius: 999,
            background: "#e8f0fe",
            color: "#1a73e8",
            fontSize: 11,
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          Nouveau
        </span>
        Nouveauté
      </div>

      {nouvelles.map((n) => (
        <div key={n.id} style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#0b1b2a" }}>
            {n.titre}
          </div>
          <div
            style={{
              fontSize: 12,
              lineHeight: 1.55,
              color: "#5f7a90",
              marginTop: 3,
            }}
          >
            {n.description}
          </div>
        </div>
      ))}

      <div style={{ fontSize: 11, color: "#5f7a90", opacity: 0.85 }}>
        Version {nouvelles[0].version} —{" "}
        {new Date(nouvelles[0].date).toLocaleDateString("fr-FR")}
      </div>
    </div>
  );
}

export default { PastilleNouveaute, BlocNouveaute };
